module.exports = __webpack_public_path__ + "img/desk3.a7189d00.png";